export const SERVICE_WORKER_PATH = "/sw.js";

export const SERVICE_WORKER_SCOPE = "/";

/** Message the worker listens for to activate a waiting build; mirrored in `public/sw.js`. */
export const SKIP_WAITING_MESSAGE = "SKIP_WAITING";

/** Re-check for a new build whenever the tab has been in the background this long. */
export const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;

export const PWA_UPDATE_MESSAGE = "A new version of eCarehealth is available.";

export const PWA_UPDATE_ACTION_LABEL = "Reload";

export const PWA_UPDATE_DISMISS_LABEL = "Later";

export const PWA_UPDATE_SNACKBAR_ORIGIN = {
  vertical: "bottom",
  horizontal: "left",
} as const;
